module.exports = __webpack_public_path__ + "img/icon_project-info.48be67c5.svg";